import React from 'react';
import ResourceList from './resource-list'

const UserList = (props) => (
    <ResourceList {...props} fields={['lastname', 'firstname', 'email']} labels={['Last Name', 'First Name',  'Email']}  path="/users/" />
)


export default UserList;